export const CONFIG_AUTH = false;
